module.exports = __webpack_public_path__ + "img/122.4.4bb2b050.png";